document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('CartDrawer');

  if (!drawer) return;

  const panel = drawer.querySelector('.cart-drawer__panel');
  const overlay = drawer.querySelector('.cart-drawer__overlay');
  const itemsContainer = document.getElementById('CartDrawerItems');
  const subtotalElement = document.getElementById('CartDrawerSubtotal');

  let isUpdating = false;

  /* -----------------------------------------
     OPEN
  ----------------------------------------- */

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  /* -----------------------------------------
     CLOSE
  ----------------------------------------- */

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  /* -----------------------------------------
     ADD TO CART
  ----------------------------------------- */

  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form.matches('form[action*="/cart/add"]')) {
      return;
    }

    /*
     * Don't interfere with forms that have been
     * specifically marked to skip the drawer.
     */
    if (form.dataset.cartDrawerIgnore === 'true') {
      return;
    }

    event.preventDefault();

    if (isUpdating) return;

    const button = form.querySelector(
      'button[type="submit"], input[type="submit"], [name="add"]'
    );

    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(
              data.description || 'Unable to add product'
            );
          });
        }

        return response.json();
      })
      .then(function () {
        /*
         * Get the updated cart once.
         */
        return fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        updateCartCount(cart.item_count);

        /*
         * Open immediately after cart is ready.
         */
        requestAnimationFrame(function () {
          openDrawer();
        });
      })
      .catch(function (error) {
        console.error('Cart error:', error);
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
        }
      });
  });

  /* -----------------------------------------
     DRAWER ACTIONS
  ----------------------------------------- */

  drawer.addEventListener('click', function (event) {

    /*
     * Close
     */
    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    /*
     * IMPORTANT:
     * Allow View Cart and Checkout links to work normally.
     */
    if (
      event.target.closest('.cart-drawer__view-cart') ||
      event.target.closest('.cart-drawer__checkout')
    ) {
      return;
    }

    /*
     * Quantity +
     */
    const plus = event.target.closest('[data-cart-plus]');

    if (plus) {
      event.preventDefault();

      const line = Number(plus.dataset.line);
      const quantityElement = plus
        .closest('.cart-item')
        ?.querySelector('[data-cart-quantity]');

      const currentQuantity = Number(
        quantityElement?.textContent.trim() || 1
      );

      updateCartItem(line, currentQuantity + 1);
      return;
    }

    /*
     * Quantity -
     */
    const minus = event.target.closest('[data-cart-minus]');

    if (minus) {
      event.preventDefault();

      const line = Number(minus.dataset.line);
      const quantityElement = minus
        .closest('.cart-item')
        ?.querySelector('[data-cart-quantity]');

      const currentQuantity = Number(
        quantityElement?.textContent.trim() || 1
      );

      updateCartItem(line, Math.max(0, currentQuantity - 1));
      return;
    }

    /*
     * Remove
     */
    const remove = event.target.closest('[data-cart-remove]');

    if (remove) {
      event.preventDefault();

      const line = Number(remove.dataset.line);

      updateCartItem(line, 0);
      return;
    }
  });

  /* -----------------------------------------
     UPDATE CART
  ----------------------------------------- */

  function updateCartItem(line, quantity) {

    if (isUpdating) return;

    isUpdating = true;

    const item = drawer.querySelector(
      `.cart-item[data-line="${line}"]`
    );

    if (item) {
      item.classList.add('is-updating');
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to update cart');
        }

        return response.json();
      })
      .then(function (cart) {

        /*
         * Shopify returns the complete cart.
         * No second /cart.js request needed.
         */
        renderCart(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function (error) {
        console.error('Cart update error:', error);
      })
      .finally(function () {
        isUpdating = false;
      });
  }

  /* -----------------------------------------
     RENDER CART
  ----------------------------------------- */

  function renderCart(cart) {

    if (!itemsContainer) return;

    if (!cart.items.length) {

      itemsContainer.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your cart is empty.</p>

          <button type="button" data-cart-close>
            Continue Shopping
          </button>
        </div>
      `;

      if (subtotalElement) {
        subtotalElement.textContent = formatMoney(cart.total_price);
      }

      return;
    }

    itemsContainer.innerHTML = cart.items
      .map(function (item, index) {

        const line = index + 1;

        const image = item.image
          ? `
            <img
              src="${item.image}&width=160"
              alt="${escapeHtml(item.product_title)}"
              width="90"
              height="90"
              loading="lazy"
            >
          `
          : '';

        const variant =
          item.variant_title &&
          item.variant_title !== 'Default Title'
            ? `
              <div class="cart-item__variant">
                ${escapeHtml(item.variant_title)}
              </div>
            `
            : '';

        return `
          <div
            class="cart-item"
            data-line="${line}"
          >

            <div class="cart-item__image">
              ${image}
            </div>

            <div class="cart-item__content">

              <a
                href="${item.url}"
                class="cart-item__title"
              >
                ${escapeHtml(item.product_title)}
              </a>

              ${variant}

              <div class="cart-item__price">
                ${formatMoney(item.final_line_price)}
              </div>

              <div class="cart-item__bottom">

                <div class="cart-item__quantity">

                  <button
                    type="button"
                    data-cart-minus
                    data-line="${line}"
                    aria-label="Decrease quantity"
                  >
                    −
                  </button>

                  <span data-cart-quantity>
                    ${item.quantity}
                  </span>

                  <button
                    type="button"
                    data-cart-plus
                    data-line="${line}"
                    aria-label="Increase quantity"
                  >
                    +
                  </button>

                </div>

                <button
                  type="button"
                  class="cart-item__remove"
                  data-cart-remove
                  data-line="${line}"
                >
                  Remove
                </button>

              </div>

            </div>

          </div>
        `;
      })
      .join('');

    if (subtotalElement) {
      subtotalElement.textContent =
        formatMoney(cart.total_price);
    }
  }

  /* -----------------------------------------
     CART COUNT
  ----------------------------------------- */

  function updateCartCount(count) {

    const counters = document.querySelectorAll(
      '[data-cart-count], .cart-count, .cart-item-count'
    );

    counters.forEach(function (counter) {

      counter.textContent = count;

      if (count > 0) {
        counter.classList.remove('hidden');
      } else {
        counter.classList.add('hidden');
      }

    });
  }

  /* -----------------------------------------
     CART ICON
  ----------------------------------------- */

  document.addEventListener('click', function (event) {

    const cartLink = event.target.closest(
      'a[href="/cart"], a[href^="/cart?"]'
    );

    if (!cartLink) return;

    /*
     * DON'T intercept View Cart inside drawer.
     */
    if (cartLink.closest('#CartDrawer')) {
      return;
    }

    event.preventDefault();

    fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        updateCartCount(cart.item_count);
        openDrawer();
      });
  });

  /* -----------------------------------------
     OVERLAY
  ----------------------------------------- */

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  /* -----------------------------------------
     ESC
  ----------------------------------------- */

  document.addEventListener('keydown', function (event) {

    if (event.key === 'Escape') {
      closeDrawer();
    }

  });

  /* -----------------------------------------
     MONEY
  ----------------------------------------- */

  function formatMoney(cents) {

    const currency =
      window.cartDrawerCurrency ||
      'USD';

    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  /* -----------------------------------------
     ESCAPE HTML
  ----------------------------------------- */

  function escapeHtml(value) {

    const div = document.createElement('div');

    div.textContent = value || '';

    return div.innerHTML;
  }
});